import { useEffect, useState } from 'react';
import { useStore } from 'store/store';
import {
  useUiListAccounts,
  useCreateAccount,
  PageToken,
  getReportingAccountsTransactions,
  getReportingCardaccountsTransactions
} from '@utx/utx-access-client';
import { ACCESS_BASE_URL } from 'App';

export interface useCardAccountsParams {
  id?: string;
  name?: string;
  search?: string;
  pageSize?: number;
}

export const useListAccounts = ({ id, name, search, pageSize = 10 }: useCardAccountsParams) => {
  const store = useStore();

  const [currentPageToken, setCurrentPageToken] = useState<PageToken>();
  const [pageToken, setPageToken] = useState<{ nextToken?: PageToken; preToken?: PageToken }>({});
  const [enabled, setEnabled] = useState<boolean>(false);
  setTimeout(() => {
    setEnabled(store.authToken ? true : false);
  }, 100);

  const queryAccounts = useUiListAccounts(
    {
      accountId: id,
      name: name,
      search: search,
      pageSize: pageSize,
      pageToken: currentPageToken
    },
    {
      axios: {
        baseURL: ACCESS_BASE_URL
      },
      query: {
        queryKey: ['queryAccounts', store.authToken, currentPageToken, pageSize, name, search],
        retry: false,
        enabled,
        keepPreviousData: true
      }
    }
  );

  // useEffect(() => {
  //   queryAccounts.refetch();
  // }, [id, name, pageSize, pageToken]);

  useEffect(() => {
    setPageToken({ nextToken: queryAccounts.data?.data.nextPageToken, preToken: queryAccounts.data?.data.prevPageToken });
  }, [queryAccounts.data?.data]);

  const createAccountMutate = useCreateAccount({ axios: { baseURL: ACCESS_BASE_URL } });
  const createAccount = (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
    createAccountMutate.mutate(
      { data },
      {
        onSuccess,
        onError
      }
    );
  };

  return {
    accounts: queryAccounts.data?.data.accounts || [],
    isLoading: queryAccounts.isLoading,
    nextToken: pageToken.nextToken,
    preToken: pageToken.preToken,
    prev: () => setCurrentPageToken(pageToken.preToken),
    next: () => setCurrentPageToken(pageToken.nextToken),
    refetch: () => queryAccounts.refetch(),
    clearCurrentPageToken: () => {
      setCurrentPageToken(undefined);
    },
    createAccount
  };
};

export interface getReportingAccountsTransactionsParams {
  dateRangeFrom?: string;
  dateRangeTo?: string;
  walletId?: string;
}

export interface getReportingCardaccountsTransactionsParams {
  dateRangeFrom?: string;
  dateRangeTo?: string;
  creditLineId?: string;
}

export const useReportingTransactions = () => {
  const reportingAccountsTransactions = ({ dateRangeFrom, dateRangeTo, walletId }: getReportingAccountsTransactionsParams) => {
    return getReportingAccountsTransactions(
      {
        dateRangeFrom: dateRangeFrom,
        dateRangeTo: dateRangeTo,
        walletId: walletId
      },
      {
        baseURL: ACCESS_BASE_URL
      }
    );
  };

  const reportingCardaccountsTransactions = ({ dateRangeFrom, dateRangeTo, creditLineId }: getReportingCardaccountsTransactionsParams) => {
    return getReportingCardaccountsTransactions(
      {
        dateRangeFrom: dateRangeFrom,
        dateRangeTo: dateRangeTo,
        creditLineId: creditLineId
      },
      {
        baseURL: ACCESS_BASE_URL
      }
    );
  };

  return {
    reportingAccountsTransactions,
    reportingCardaccountsTransactions
  };
};
